import React from 'react';
import { useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import SelectField from '../../common/components/SelectField';
import clientSelector from '../../clients/clientSelector';
import documentationSelector from '../../documentation/documentationSelector';
import createClientStatistics from './createClientStatistics';
import createDocumentationStatistics from './createDocumentationStatistics';
import statistics from '../../common/helpers/statistics';
import type { StatisticsFilter as StatisticsFilterType } from '../../common/types/statistics/statistics';
import type { Statistic } from '../../common/types/statistics/fbStatistics';
import settingsSelectors from '../../settings/settingsSelector';
import { Setting } from '../../common/types/settings';

type Props = {
  filterStartYear: number;
  setStatistic: (statistic: Statistic) => void;
};

function StatisticsFilter({ filterStartYear, setStatistic }: Props) {
  const clients = useSelector(clientSelector.getClients);
  const documentation = useSelector(documentationSelector.getDocumentation);
  const advisor = useSelector(settingsSelectors.getAdvisors);
  const groups = useSelector(settingsSelectors.getGroups);

  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - filterStartYear >= 0 ? currentYear - filterStartYear : 0;

  const years = new Array(yearDifference + 1).fill(0).map((_, index) => {
    const year = currentYear - index;
    return { label: `${year}`, value: `${year}` };
  });

  const advisorOptions = advisor.map((adivsor: Setting) => {
    return { label: adivsor.value, value: adivsor.value };
  });

  const [statisticFilter, setStatisticFilter] = React.useState<StatisticsFilterType>(statistics.defaultFilter);

  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0 48px 0',
        padding: '20px 24px',
        minWidth: '300px',
        maxWidth: '650px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Typography fontSize='1.2rem' mb={2}>
        Filter
      </Typography>
      <Grid container rowSpacing={2} columnSpacing={4}>
        <Grid item xs={6}>
          <SelectField
            label='Jahr'
            options={years}
            value={statisticFilter.year}
            fullWidth
            handleChange={(value) => {
              if (typeof value === 'string') {
                setStatisticFilter({ ...statisticFilter, year: value });
              }
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectField
            label='Beraterin'
            options={[{ label: 'Keine Beraterin', value: '' }].concat(advisorOptions)}
            value={statisticFilter.advisor}
            fullWidth
            handleChange={(value) => {
              if (typeof value === 'string') {
                setStatisticFilter({ ...statisticFilter, advisor: value });
              }
            }}
          />
        </Grid>
      </Grid>
      <Button
        variant='contained'
        onClick={() => {
          if (clients != null) {
            const clientStatistics = createClientStatistics(clients, statisticFilter);
            const documentationStatistics = createDocumentationStatistics(documentation, statisticFilter, groups);
            setStatistic({ clientStatistics, documentationStatistics });
          }
        }}
        sx={{ marginTop: '16px', marginLeft: 'auto' }}
      >
        Statistik anzeigen
      </Button>
    </Paper>
  );
}

export default StatisticsFilter;
